export default __webpack_public_path__ + "static/media/Apercu-BoldItalic.d789566c.otf";